import React, { PropsWithChildren } from 'react';

import { useServiceNotice } from '~/contexts/service-notice';
import { ServiceUnavailableScreen } from '~/screens/service-unavailable';

/**
 * Renders the rest of the app only while the service notice state allows it:
 * - 'unknown': the persisted notice state is still being read, render nothing yet
 *   (same boot behavior as AppIntlProvider while it reads the stored locale)
 * - 'unavailable': the notice validity has passed and the service is no longer available,
 *   render only the static screen so nothing network-capable ever mounts
 * - 'active': render the app normally
 *
 * Kept in its own module (instead of inline in app-component) so the mapping can be
 * unit-tested without pulling in the whole app/navigator graph.
 */
export function ServiceNoticeGate(props: PropsWithChildren<object>) {
    const { children } = props;
    const { state } = useServiceNotice();

    if (state === 'unknown') {
        return null;
    }

    if (state === 'unavailable') {
        return <ServiceUnavailableScreen />;
    }

    return <>{children}</>;
}
